import {
    AfterViewInit,
    Directive,
    ElementRef
  } from '@angular/core';
  
  @Directive({
    standalone: true,
    selector: '[pplAutoFocusHeader]'
  })

  export class AutoFocusHeaderDirective implements AfterViewInit {
  
    constructor(private el: ElementRef) {}
  
    ngAfterViewInit() {
      setTimeout(() => {
        this.el.nativeElement.focus();
      });
    }
  }
  